// extracted by mini-css-extract-plugin
export default {"topNavigationBarContainer":"TopNavigationBar_topNavigationBarContainer__OgU7G","borderBottom":"TopNavigationBar_borderBottom__Rv4TC","emptyBox":"TopNavigationBar_emptyBox__aRwlB"};